<template>
  <div class="pb-24 mt-24">
    <a-collapse :activeKey="1" accordion :bordered="false">
      <template #expandIcon="{ isActive }">
        <span :class="isActive ? 'icon-open' : 'icon-closed'"></span>
      </template>
      <a-collapse-panel v-for="group in portals" :key="group.id">
        <template slot="header">
          <div class="accordion-title">
            <div class="accordion-title__name">{{ group.continent }}</div>
            <div class="d-none d-md-block text-truncate">{{ group.desc }}</div>
          </div>
        </template>
        <div class="link-columns">
          <template v-for="(link, index) in group.links">
            <span class="link-columns__item" :key="index">
              <span class="arrow-right"></span>
              {{ link }}</span
            >
          </template>
        </div>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
import { portaleGrupy } from "./portaleGrupy.js";

export default {
  data: () => ({
    portals: portaleGrupy.groups
  })
};
</script>

<style lang="scss" scoped>
::v-deep {
  .ant-collapse {
    border-radius: 6px;
    overflow: hidden;

    > .ant-collapse-item {
      border-bottom: 0;

      &:first-of-type {
        > .ant-collapse-header {
          border-radius: 6px 6px 0 0;
        }
      }

      &:last-of-type {
        > .ant-collapse-header {
          border-bottom-width: 1px;

          border-radius: 0 0 6px 6px;
        }
      }

      &:last-of-type {
        > .ant-collapse-content {
          border-radius: 0 0 6px 6px;
        }
      }

      > .ant-collapse-header {
        border-color: $gray-20;
        border-style: solid;
        border-width: 1px 1px 0px 1px;
        padding-left: 42px;
        transition: all ease-in-out 0.1s;

        .ant-collapse-arrow {
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          left: 12px;
          height: 20px;
          width: 20px;
          transition: all ease-in-out 0.1s;

          &:before,
          &:after {
            background-color: #fff;
            content: "";
            display: block;
            position: absolute;
            transition: all ease-in-out 0.1s;
          }

          &:after {
            height: 2px;
            width: 12px;
          }

          &:before {
            height: 12px;
            width: 2px;
            opacity: 0;
          }

          &.icon-open {
            background-color: #fff;

            &:after {
              background-color: $blue-light;
            }
          }

          &.icon-closed {
            background-color: $blue-light;

            &:before {
              opacity: 1;
            }
          }
        }
      }

      &-active {
        > .ant-collapse-header {
          background-color: $blue-light;
          border-color: $blue-light;
          color: #fff;
        }

        &:last-of-type {
          > .ant-collapse-header {
            border-radius: 0;
          }

          > .ant-collapse-content {
            border-bottom-width: 1px;
          }
        }
      }

      > .ant-collapse-content {
        border-color: $gray-20;
        border-style: solid;
        border-width: 0 1px;

        > .ant-collapse-content-box {
          background-color: #fff;
          padding-top: 20px;
          padding-bottom: 20px;
        }
      }
    }
  }
}

.accordion-title {
  display: flex;
  align-items: center;

  &__name {
    @include font-m();
    flex: 0 0 180px;
  }
}

.link-columns {
  column-gap: 24px;

  @media (min-width: $screen-xxs - 60) {
    column-count: 2;
    column-width: 50%;
  }

  @media (min-width: $screen-sm) {
    column-count: 4;
    column-width: 25%;
  }

  &__item {
    @include text-truncate;
    display: block;
    padding-top: 4px;
  }
}

.arrow-right {
  border: solid $gray-50;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 3px;
  margin-right: 6px;
  position: relative;
  top: -1px;
  transform: rotate(-45deg);
}
</style>
